import {
  Alert,
  Box,
  Button,
  Flex,
  NumberInput,
  ScrollArea,
  Select,
  Table,
  Text,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import {
  IconAlertCircle,
  IconAlertTriangle,
  IconCheck,
} from "@tabler/icons-react";
import axios from "axios";
import cx from "clsx";
import { memo, useCallback, useEffect, useState } from "react";
import {
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  isAhamoveNeedForce,
  pushAhamoveOrder,
} from "../../../api/apiDeliveryPartner";
import classes from "../../../Styles/TableScrollArea.module.css";
import { handleGetInfoWarehouse } from "../DeliveryPartner/helper";

interface dataProduct {
  quantity: number;
  weight: number;
  product_code: number;
  name: string;
  price: number;
}

interface ProductRowProps {
  item: dataProduct;
  onUpdateWeight: (
    id: string,
    field: "weight" | "weightPackage",
    value: number,
  ) => void;
}

const ProductRow = memo(({ item, onUpdateWeight }: ProductRowProps) => {
  return (
    <Table.Tr>
      <Table.Td w={100}>{item.product_code}</Table.Td>
      <Table.Td>{item.name}</Table.Td>
      <Table.Td w={100}>{item.quantity}</Table.Td>
      <Table.Td w={300}>
        <Flex align="center" gap={10}>
          <Text size="11.5px">Khối lượng thực tế</Text>
          <NumberInput
            placeholder="Khối lượng thực tế"
            value={item.weight}
            // Gọi hàm cập nhật cho weight
            onChange={(val) =>
              onUpdateWeight(String(item.product_code), "weight", Number(val))
            }
            hideControls
            allowNegative={false}
            suffix=" kg"
            size="xs"
          />
        </Flex>
      </Table.Td>
    </Table.Tr>
  );
});

const GHTKAndAhamove = ({
  data,
  onSuccess,
  typeGet,
}: {
  data: any;
  onSuccess: any;
  typeGet: string;
}) => {
  // console.log(data);
  const [type, setType] = useState<string>("");
  const [dataProduct, setDataProduct] = useState<dataProduct[]>([]);
  const [dataAttribute1, setDataAttribute1] = useState<any>();
  const [typeAhamove, setTypeAhamove] = useState<string>("");
  const [isPackTheGoods, setIsPackTheGoods] = useState<string>("");
  const [amountTotalOrder, setAmountTotalOrder] = useState<number>(0);
  const [amountTotalTransfer, setAmountTotalTransfer] = useState<number>(0);
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [totalBox, setTotalBox] = useState<number>(1);

  const [provinceName, setProvinceName] = useState<string>("");
  const [communeName, setCommuneName] = useState<string>("");

  const [provinceBranch, setProvinceBranch] = useState<string>("");
  const [communeBranch, setCommuneBranch] = useState<string>("");
  const [addressBranch, setAddressBranch] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");

  const [scrolled, setScrolled] = useState(false);

  // Đẩy Ahamove qua API BE push-order
  // Có giá trị khi phải hỏi xác nhận tạo lại đơn Ahamove (gọi lại với force = true)
  const [ahamoveForceMessage, setAhamoveForceMessage] = useState<string | null>(
    null,
  );
  const [ahamoveError, setAhamoveError] = useState<string | null>(null);
  // Ahamove có thể đã tạo đơn nên không cho bấm lại ngay
  const [ahamoveLocked, setAhamoveLocked] = useState<boolean>(false);

  const deliveryOptions = [
    { label: "Giao hàng tiết kiệm", value: "1" },
    { label: "Ahamove", value: "2" },
  ];

  const customHeightTable = () => {
    if (dataProduct.length <= 1 || !dataProduct) {
      return 110;
    } else if (dataProduct.length === 2) {
      return 150;
    } else if (dataProduct.length === 3) {
      return 190;
    } else if (dataProduct.length === 4) {
      return 230;
    } else {
      return 270;
    }
  };

  const addressDiemDi = async () => {
    if (data?.attribute28) {
      const res = await repositoryDelivery.get<MessageResponse<any>>(
        `/api/v1/TblDmMasterOrg/detail?id=${data?.attribute28}`,
      );
      if (res && res.success) {
        const result = res.data;
        getDetailProvince(result?.attribute8, "branch");
        getDetailCommune(result?.attribute9, "branch");
        setAddressBranch(result?.address);
        setPhoneNumber(result?.phone);
      }
    }
  };

  const addressDiemDen = async () => {
    const res = await repositoryDelivery.get<MessageResponse<any>>(
      `/api/v1/TblDmMasterOrg/detail?id=${data?.customerId}`,
    );

    if (res && res.success) {
      const result = res.data;
      if (result?.attribute1) {
        getDetailProvince(result?.attribute8, "address");
      }
      if (result?.attribute3) {
        getDetailCommune(result?.attribute9, "address");
      }
    }
  };

  const getDetailProvince = async (id: string | number, type: string) => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblDmProvinceMoi/detail?id=${id?.toString()}`,
    );

    if (res && res.success) {
      if (type === "address") {
        setProvinceName(res?.data?.name);
      } else if (type === "branch") {
        setProvinceBranch(res?.data?.name);
      }
    }
  };

  const getDetailCommune = async (id: string | number, type: string) => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblDmCommuneMoi/detail?id=${id?.toString()}`,
    );

    if (res && res.success) {
      if (type === "address") {
        setCommuneName(res?.data?.name);
      } else if (type === "branch") {
        setCommuneBranch(res?.data?.name);
      }
    }
  };

  const dataTypeAhamove = [
    { label: "Siêu tốc", value: "HAN-BIKE" },
    { label: "Siêu tốc tiết kiệm", value: "HAN-ECO" },
    // { label: "Đồng giá 25k", value: "HAN-SAMEPRICE" },
    { label: "Siêu tốc", value: "SGN-BIKE" },
    { label: "Siêu tốc tiết kiệm", value: "SGN-ECO" },
  ];

  const getDataProduct = async () => {
    const res = await repositoryDelivery.get<MessageResponse<any>>(
      `/api/v1/TblDelivery/detail-delivery-v2?Id=${data?.id}&ItemsOnly=false&IsOutWarded=true`,
    );

    if (res && res?.success) {
      const result = res.data?.listItemDeliveries;
      console.log(result);
      // const dataProduct = result.map((item: any) => ({
      //   quantity: item.primaryQuantity,
      //   weight: 0.1,
      //   product_code: item.itemId,
      //   name: item.itemName,
      //   price: item.totalLineAmount ? item.totalLineAmount : 0,
      // }));
      // setDataProduct(dataProduct);
      getDataProductWeight(result);
    }
  };

  const getDataProductWeight = async (listProduct: any[]) => {
    let url = "/api/v1/TblItem/get-attribute54-by-item-codes";

    if (listProduct) {
      url += "?" + listProduct.map((i) => `ItemCodes=${i.itemCode}`).join("&");
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const data = res.data;

      const products = listProduct.map((item: any) => ({
        quantity: item.primaryQuantity,
        weight:
          Number(
            data.find((i: any) => i.itemCode === item.itemCode)?.attribute54,
          ) / 1000 || 0.1,
        product_code: item.itemId,
        name: item.itemName,
        price: item.totalLineAmount ? item.totalLineAmount : 0,
      }));
      setDataProduct(products);
    }
  };

  const handleUpdateWeight = useCallback(
    (id: string, field: "weight" | "weightPackage", value: number) => {
      setDataProduct((prevData) =>
        prevData.map((item) => {
          if (String(item.product_code) === id) {
            const numValue = Number(value) || 0;

            if (field === "weight") {
              return {
                ...item,
                weight: numValue,
              };
            }

            return { ...item, [field]: value };
          }
          return item;
        }),
      );
    },
    [],
  );

  const getDataOrder = async () => {
    if (data?.sourceType === 1) {
      const response = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/CreateSellItem/details?orderNumber=${data?.sourceCode}`,
      );

      if (response && response.success) {
        const result = JSON.parse(
          response.data?.orderHeader?.attribute1 || "{}",
        );
        setDataAttribute1(result);
        setAmountTotalOrder(response.data?.orderHeader?.amountTotal);
      }
    }
  };

  const getDataWarehouseTransfer = async () => {
    if (data?.sourceType === 2) {
      const response = await repositoryMdm.get<MessageResponse<any>>(
        `/api/v1/TblRequestTransfer/detail?code=${data?.sourceCode}`,
      );

      if (response && response.success) {
        const result = response.data;
        if (
          result?.tblRequestTransferDetailModels &&
          Array.isArray(result?.tblRequestTransferDetailModels) &&
          result?.tblRequestTransferDetailModels.length > 0
        ) {
          const dataTotal = result?.tblRequestTransferDetailModels?.reduce(
            (sum: any, item: any) => sum + item?.poPrice,
            0,
          );
          setAmountTotalTransfer(dataTotal);
        } else {
          setAmountTotalTransfer(0);
        }
      }
    }
  };

  const createAhamoveOrder = async (data: any) => {
    try {
      const response = await axios.post(
        "https://partner-apistg.ahamove.com/v3/orders",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXAiOiJ1c2VyIiwiY2lkIjoiODQ5NjQ2MzUxMzYiLCJzdGF0dXMiOiJPTkxJTkUiLCJlb2MiOiJ2YW52aW5oc3B1ckBnbWFpbC5jb20iLCJub2MiOiJDw7RuZyB0eSBD4buVIHBo4bqnbiDEkOG6p3UgdMawIEPDtG5nIG5naOG7hyBIQUNPTSBBZG1pbiIsImN0eSI6IlNHTiIsInR5cGUiOiJhcGkiLCJwYXJ0bmVyIjoiaGFjb20iLCJleHAiOjE4MTY5NDM5MDUsImlhdCI6MTc1Mzg3MTkwNSwiaXNzIjoiYWhhIn0.fO6fONjUfp2KzIlgYX5HjeNa06UfFxa1BEVHANnrj7U", // 🔁 Thay <token> bằng token thật từ Postman
          },
        },
      );

      console.log("Ahamove response:", response.data);
      return response;
    } catch (error: any) {
      console.error(
        "Ahamove API error:",
        error.response?.data || error.message,
      );
      return error.response?.data || error.message;
    }
  };

  const handleUpdateDelivery = async (type: number) => {
    const res = await repositoryDelivery.post<MessageResponse<any>>(
      "/api/v1/TblDelivery/update-delivery-when-push-to-shipping-partner",
      {
        deliveryId: data?.id,
        note: type === 1 ? "Đẩy đơn sang GHTK" : "Đẩy đơn sang Ahamove",
        type: type,
      },
    );

    if (res && res?.success) {
      NotificationExtension.Success(
        type === 1
          ? "Đẩy đơn GHTK thành công !"
          : "Đẩy đơn Ahamove thành công !",
      );
    }
  };

  const handleGHTK = async () => {
    setLoadingButton(true);
    const dataWarehouse = handleGetInfoWarehouse(Number(data?.attribute28));

    const responseGHTK = await repositoryMdm.post<any>(
      "/api/v1/GHTK/create-order",
      {
        // Cập nhật đơn giao hàng nằm luôn trong API này,
        // chạy chung transaction với việc đẩy sang GHTK
        deliveryId: data?.id,
        note: "Đẩy đơn sang GHTK",
        order: {
          products: dataProduct?.map((item) => ({
            quantity: item.quantity,
            weight: item.weight,
            product_code: item.product_code,
            name: item.name,
          })),
          order: {
            id: data?.sourceCode,
            pick_name: "Nội thành",
            pick_address: dataAttribute1?.isOffice124
              ? "124 Minh Khai, Hai Bà Trưng, Hà Nội"
              : addressBranch && addressBranch.length > 0
                ? addressBranch
                : dataWarehouse?.pick_address,
            pick_province: dataAttribute1?.isOffice124
              ? "Hà Nội"
              : provinceBranch && provinceBranch.length > 0
                ? provinceBranch
                : dataWarehouse?.pick_province,
            pick_district: dataAttribute1?.isOffice124 ? "Hai Bà Trưng" : null,
            pick_ward: dataAttribute1?.isOffice124
              ? "Minh Khai"
              : communeBranch && communeBranch.length > 0
                ? communeBranch
                : dataWarehouse?.pick_ward,
            pick_tel:
              dataAttribute1?.isOffice124 &&
              (dataAttribute1?.senderPhone || dataAttribute1?.pick_tel)
                ? dataAttribute1?.senderPhone || dataAttribute1?.pick_tel
                : phoneNumber && phoneNumber.length > 0
                  ? phoneNumber
                  : dataWarehouse?.pick_tel,
            tel: data?.telephoneNumber,
            name: data?.customerName,
            address: data?.toAddress,
            province: provinceName,
            district: null,
            ward: communeName,
            hamlet: "Khác",
            is_freeship: "1",
            pick_money:
              data?.debt === "Giao Hàng Thu Tiền(COD)"
                ? Math.max(
                    0,
                    (data?.amountRemaining || 0) -
                      (Number(data?.attribute60) || 0),
                  )
                : 0,
            note: "",
            value:
              data?.sourceType === 2
                ? amountTotalTransfer && !isNaN(amountTotalTransfer)
                  ? amountTotalTransfer
                  : 1
                : data?.sourceType === 1
                  ? amountTotalOrder
                  : 0,
            pick_option: "cod",
            total_box: totalBox,
          },
        },
      },
    );
    if (responseGHTK?.success) {
      // Mã tra cứu đơn giờ do API create-order tự ghi vào attribute1,
      // chạy chung transaction với phần còn lại nên không cần gọi thêm ở đây
      NotificationExtension.Success("Đẩy đơn GHTK thành công !");

      setTimeout(() => {
        modals.closeAll();
        setLoadingButton(false);
        onSuccess(typeGet, "Đẩy đơn GHTK thành công !");
      }, 1500);
    } else {
      setLoadingButton(false);
      setTimeout(() => {
        NotificationExtension.Fails(
          `Tạo đơn GHTK thất bại: ${responseGHTK?.message}`,
        );
      }, 1000); // Delay 200ms

      // Ghi log lỗi vào hệ thống
      await repositoryPos.post("/api/v1/CreateSellItem/update-ghtk-log", {
        orderNumber: data?.sourceCode,
        attribute42:
          responseGHTK?.message || "Lỗi không xác định khi tạo đơn GHTK",
      });
    }
  };

  const handleAhamove = async () => {
    setLoadingButton(true);
    const dataWarehouse = handleGetInfoWarehouse(Number(data?.attribute28));

    const addressAhamove = data?.toAddress
      .replace(/ - /g, ", ")
      .replace(/-/g, ", ");

    const items = dataProduct.map((item: any) => ({
      _id: item.product_code, // hoặc chuyển thành chuỗi: String(item.itemId)
      num: item.quantity, // số lượng
      name: item.name, // tên sản phẩm
      price: item.price || 0, // giá (nếu không có thì để 0)
    }));

    const dataAhamove = {
      order_time: 0,
      path: [
        {
          // lat: 10.76975346,
          address: dataAttribute1?.isOffice124
            ? "124 Minh Khai, Hai Bà Trưng, Hà Nội"
            : addressBranch && addressBranch.length > 0
              ? addressBranch
                  .split("-")
                  .map((i) => i.trim())
                  .join(", ")
              : dataWarehouse?.pick_address
                  ?.split("-")
                  .map((i) => i.trim())
                  .join(", "),
          short_address: dataAttribute1?.isOffice124
            ? "Hà Nội"
            : provinceBranch,
          name: dataAttribute1?.isOffice124
            ? "Văn phòng Hacom 124"
            : "Giao vận Hacom",
          mobile:
            dataAttribute1?.isOffice124 &&
            (dataAttribute1?.senderPhone || dataAttribute1?.pick_tel)
              ? dataAttribute1?.senderPhone || dataAttribute1?.pick_tel
              : "0988655130",
          remarks: "Đến nơi lấy hàng đọc mã đơn để nhận hàng",
        },
        {
          // lat: 10.8018493,
          // lng: 106.714466,
          address: addressAhamove,
          short_address: provinceName,
          name: data?.customerName,
          mobile: data?.telephoneNumber,
          cod:
            data?.debt === "Giao Hàng Thu Tiền(COD)"
              ? Math.max(
                  0,
                  (data?.amountRemaining || 0) -
                    (Number(data?.attribute60) || 0),
                )
              : 0,
          item_value: amountTotalOrder,
          tracking_number: data?.sourceCode,
          remarks: "Gọi điện trước khi giao. Giao hàng cẩn thận",
        },
      ],
      service_id: typeAhamove,
      // requests: [
      //   {
      //     _id: typeAhamoveShip,
      //   },
      // ],
      payment_method: "CASH",
      remarks:
        "Tài xế không cần gọi shop , vào trực tiếp của hàng , đọc mã đơn cho bộ phận kho để lấy hàng",
      items: items,
      // package_detail: [
      //   {
      //     weight: 10,
      //     length: 1.2,
      //     width: 0.8,
      //     height: 2.0,
      //     description: "Linh kiện máy tính",
      //   },
      // ],
    };
    const responseAhamove = await createAhamoveOrder(dataAhamove);
    if (responseAhamove?.data?.order_id) {
      NotificationExtension.Success("Đẩy đơn Ahamove thành công !");
      const updatedAttribute1 = {
        ...dataAttribute1,
        sharedLink: responseAhamove?.order?.tracking_id,
      };

      // Chuyển lại thành JSON và lưu vào database
      const res = await repositoryPos.post(
        "/api/v1/CreateSellItem/update-attribute1",
        {
          orderNumber: data?.sourceCode,
          attribute1: JSON.stringify(updatedAttribute1),
        },
      );

      if (res && res.success) {
        NotificationExtension.Success("Đẩy đơn Ahamove thành công !");
      }

      setLoadingButton(false);

      handleUpdateDelivery(2);
      setTimeout(() => {
        setLoadingButton(false);
        modals.closeAll();
        onSuccess(typeGet, "Đẩy đơn Ahamove thành công !");
      }, 1500);
    } else {
      setLoadingButton(false);
      setTimeout(() => {
        NotificationExtension.Fails(
          `Tạo đơn Ahamove thất bại: ${responseAhamove?.description}`,
        );
      }, 1000); // Delay 200ms

      // Ghi log lỗi vào hệ thống
      await repositoryPos.post("/api/v1/CreateSellItem/update-ghtk-log", {
        orderNumber: data?.sourceCode,
        attribute42:
          responseAhamove?.message || "Lỗi không xác định khi tạo đơn Ahamove",
      });
    }
  };

  // Thay cho handleAhamove: FE chỉ gửi phiếu giao vận + loại giao hàng, BE tự dựng địa chỉ,
  // gọi Ahamove, lưu sharedLink và cập nhật phiếu giao vận.
  const handleAhamoveV2 = async () => {
    setLoadingButton(true);
    setAhamoveError(null);
    const res = await pushAhamoveOrder({
      deliveryId: data?.id,
      force: !!ahamoveForceMessage,
      serviceType: typeAhamove,
    });
    if (!res) {
      setLoadingButton(false);
      return;
    }

    if (res.success) {
      // await handleUpdateDelivery(2);
      setLoadingButton(false);
      modals.closeAll();
      onSuccess(typeGet, res.message);
      return;
    }

    setLoadingButton(false);
    NotificationExtension.Fails(res.message);
    if (isAhamoveNeedForce(res.message)) {
      setAhamoveForceMessage(res.message);
    } else if (res.message?.startsWith("Đơn đang được đẩy sang Ahamove")) {
      modals.closeAll();
      setTimeout(() => onSuccess(typeGet), 3000);
    } else {
      setAhamoveError(res.message);
      setAhamoveLocked(
        res.message?.startsWith("Chưa rõ kết quả tạo đơn Ahamove"),
      );
    }
  };

  useEffect(() => {
    getDataProduct();
    getDataOrder();
    getDataWarehouseTransfer();
    if (data?.customerProvinceId) {
      getDetailProvince(data?.customerProvinceId, "address");
    }
    if (data?.customerCommuneId) {
      getDetailCommune(data?.customerCommuneId, "address");
    }
    addressDiemDi();
    if (data?.sourceType === 2) {
      addressDiemDen();
    }
  }, [data?.id]);

  return (
    <Box
      w={type === "1" ? "70vw" : "40vw"}
      maw={type === "1" ? 1100 : 500}
      mt={10}
    >
      <Select
        label="Giao vận bên thứ 3"
        placeholder="Chọn bên giao vận"
        value={type}
        data={deliveryOptions}
        onChange={(e) => setType(e ? e : "")}
        clearable
      />
      {type === "1" && (
        <>
          <NumberInput
            mt={5}
            label="Số kiện hàng"
            placeholder="Nhập số kiện hàng"
            min={1}
            value={totalBox}
            onChange={(val) => setTotalBox(Number(val) || 1)}
            withAsterisk
          />
          <ScrollArea
            h={customHeightTable()}
            onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
          >
            <Table
              striped
              highlightOnHover
              withTableBorder
              withColumnBorders
              mt={10}
            >
              <Table.Thead
                className={cx(classes.header, {
                  [classes.scrolled]: scrolled,
                })}
              >
                <Table.Tr>
                  <Table.Th>ID sản phẩm</Table.Th>
                  <Table.Th>Tên sản phẩm</Table.Th>
                  <Table.Th>Số lượng</Table.Th>
                  <Table.Th>Khối lượng (kg)</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {dataProduct && dataProduct.length > 0 ? (
                  dataProduct.map((i: dataProduct) => (
                    <ProductRow
                      key={i.product_code}
                      item={i}
                      onUpdateWeight={handleUpdateWeight}
                    />
                  ))
                ) : (
                  <Table.Tr>
                    <Table.Td colSpan={4} ta={"center"}>
                      Không tìm thấy sản phẩm !
                    </Table.Td>
                  </Table.Tr>
                )}
              </Table.Tbody>
            </Table>
          </ScrollArea>
        </>
      )}
      {type === "2" && (
        <Select
          mt={5}
          label="Loại giao hàng"
          placeholder="Chọn loại giao hàng"
          value={typeAhamove}
          data={
            String(provinceBranch).toLowerCase().includes("hồ chí minh")
              ? dataTypeAhamove.filter((i: any) =>
                  String(i.value).includes("SGN"),
                )
              : dataTypeAhamove.filter((i: any) =>
                  String(i.value).includes("HAN"),
                )
          }
          onChange={(e) => {
            setTypeAhamove(e ? e : "");
          }}
          clearable
        />
      )}
      {/* {type === "1" && (
        <Select
          mt={5}
          label="Đóng gói hàng"
          placeholder="Chọn trạng thái hàng hóa"
          data={[
            { label: "Đã đóng gói", value: "DA_DONG_GOI" },
            { label: "Không đóng gói", value: "KHONG_DONG_GOI" },
          ]}
          value={isPackTheGoods ? isPackTheGoods : null}
          onChange={(e) => setIsPackTheGoods(e ? e : "")}
          withAsterisk
        />
      )} */}
      {type === "2" && ahamoveForceMessage && (
        <Alert
          mt={10}
          variant="light"
          color="orange"
          icon={<IconAlertTriangle size={18} />}
          title="Đơn có thể đã có đơn Ahamove"
        >
          <Text size="sm">{ahamoveForceMessage}</Text>
          <Text size="sm" fw={600} mt={6}>
            Chỉ tạo lại khi đã kiểm tra trên Ahamove: đơn cũ đã huỷ hoặc chưa có
            đơn.
          </Text>
        </Alert>
      )}
      {type === "2" && ahamoveError && (
        <Alert
          mt={10}
          variant="light"
          color="red"
          icon={<IconAlertCircle size={18} />}
          title={ahamoveLocked ? "Chưa rõ kết quả" : "Đẩy đơn chưa thành công"}
        >
          <Text size="sm">{ahamoveError}</Text>
        </Alert>
      )}
      <Flex mt={10} justify={"flex-end"} align={"center"}>
        <Button
          leftSection={<IconCheck />}
          color={type === "2" && ahamoveForceMessage ? "orange" : "teal"}
          loading={loadingButton}
          disabled={
            !type ||
            type.length === 0 ||
            dataProduct.length === 0 ||
            loadingButton ||
            (type === "2" &&
              (!typeAhamove || typeAhamove.length === 0 || ahamoveLocked))
          }
          onClick={() => {
            if (type === "1") {
              handleGHTK();
            } else if (type === "2") {
              // Gọi API BE push-order cho mọi đơn (bán hàng, điều chuyển...).
              // Muốn quay lại code cũ thì gọi handleAhamove().
              handleAhamoveV2();
            }
          }}
        >
          {type === "2" && ahamoveForceMessage ? "Tạo lại đơn Ahamove" : "Lưu"}
        </Button>
      </Flex>
    </Box>
  );
};

export default GHTKAndAhamove;
